import { render, staticRenderFns } from "./LeagueStats.vue?vue&type=template&id=2511cebc&scoped=true&"
import script from "./LeagueStats.vue?vue&type=script&lang=js&"
export * from "./LeagueStats.vue?vue&type=script&lang=js&"
import style0 from "./LeagueStats.vue?vue&type=style&index=0&id=2511cebc&prod&scoped=true&lang=css&"
import style1 from "./LeagueStats.vue?vue&type=style&index=1&id=2511cebc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511cebc",
  null
  
)

export default component.exports